<script setup lang="ts">
import { TeamSide } from '@collector/shared-domain'
import { Incident } from '@collector/sportsapi-client'

import { useIncidentStyle } from './useIncidentStyle'

interface Props {
  incident: Incident
  isDeleted?: boolean
  teamSide: TeamSide | null
}
defineProps<Props>()

const { getIncidentContainerClasses } = useIncidentStyle()
</script>

<template>
  <div
    class="rounded-sm border"
    :class="getIncidentContainerClasses(incident, teamSide, !!isDeleted)"
    data-testid="history-incident"
  >
    <slot></slot>
  </div>
</template>
